
export { E as LayoutFeaturedResources } from "./main-D5msFA8t.js"